import { Controller } from "@hotwired/stimulus"
import { turnCalendarPage, swapText } from "../helpers/calendar_page_turn"

// The Review modal's Desk (budgets/renewals): the strip's calendar at hero
// size, turning to each renewal in turn with the same motion
// (helpers/calendar_page_turn). The name, amount and "in N days" swap (the
// phrase comes whole from the server, each language's own plural), and the
// list below lights the bill on the calendar. Tapping a row turns the
// calendar to it and restarts the hold.
//
// Off screen nothing runs; Reduced Motion swaps with no turn. The bill on
// screen is the index value, kept on the element, so a cached snapshot and
// its controller agree on it.
const HOLD_MS = 3800

export default class extends Controller {
  static targets = ["pad", "page", "shade", "month", "day", "name", "amount", "when", "row"]
  static values = { items: Array, index: Number }

  connect() {
    this.busy = false
    this.reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches
    this.light(this.indexValue)
    if (this.itemsValue.length < 2) return

    this.observer = new IntersectionObserver(([entry]) => {
      this.visible = entry.isIntersecting
      this.visible ? this.schedule() : clearTimeout(this.timer)
    })
    this.observer.observe(this.element)
  }

  disconnect() {
    this.visible = false
    this.observer?.disconnect()
    clearTimeout(this.timer)
  }

  pick(event) {
    const index = Number(event.currentTarget.dataset.index)
    clearTimeout(this.timer)
    this.go(index).then(() => this.schedule())
  }

  schedule() {
    clearTimeout(this.timer)
    if (!this.visible) return
    this.timer = setTimeout(() => this.go((this.indexValue + 1) % this.itemsValue.length).then(() => this.schedule()), HOLD_MS)
  }

  async go(index) {
    if (this.busy || index === this.indexValue) return
    this.busy = true
    const item = this.itemsValue[index]
    this.indexValue = index
    this.light(index)

    if (this.reduce) {
      this.monthTarget.textContent = item.mon
      this.dayTarget.textContent = item.day
      this.nameTarget.textContent = item.name
      this.amountTarget.textContent = item.amount_text
      this.whenTarget.innerHTML = item.when_html
    } else {
      let copy
      await turnCalendarPage({
        page: this.pageTarget, shade: this.shadeTarget, pad: this.padTarget,
        paint: (el) => {
          el.querySelector(".rn-pad-month").textContent = item.mon
          el.querySelector(".rn-pad-day").textContent = item.day
        },
        swap: () => {
          this.monthTarget.textContent = item.mon
          this.dayTarget.textContent = item.day
          copy = swapText([this.nameTarget, this.amountTarget, this.whenTarget], () => {
            this.nameTarget.textContent = item.name
            this.amountTarget.textContent = item.amount_text
            this.whenTarget.innerHTML = item.when_html
          }, { stagger: 60 })
        }
      })
      await copy
    }
    this.busy = false
  }

  light(index) {
    this.rowTargets.forEach((row, i) => row.classList.toggle("is-on", i === index))
  }
}
